export const contactPage = {
  seo: {
    title: "聯絡我們｜來加綉綉紅豆餅",
    description:
      "歡迎聯絡來加綉綉紅豆餅，洽詢產品訂購、冷凍宅配、禮盒團購、企業下午茶、市集合作與加盟創業諮詢。",
  },
  hero: {
    tag: "聯絡我們",
    title: "聯絡來加綉綉紅豆餅",
    subtitle:
      "不論你想訂購紅豆餅、詢問冷凍宅配、規劃企業下午茶、合作活動或了解加盟，都歡迎留下需求，我們會盡快回覆。",
  },
  contactCards: {
    sectionTitle: "想詢問什麼？選擇最適合你的方式",
    cards: [
      {
        title: "產品訂購",
        desc: "詢問現烤紅豆餅、口味、數量與取貨方式。",
        icon: "ri-cake-3-line",
        cta: "加入 LINE 詢問產品",
      },
      {
        title: "冷凍宅配 / 禮盒",
        desc: "詢問宅配、禮盒、團購、企業下午茶與節慶送禮。",
        icon: "ri-truck-line",
        cta: "詢問宅配禮盒",
      },
      {
        title: "加盟創業",
        desc: "想了解副業、擺攤、市集、店面或加盟合作。",
        icon: "ri-store-3-line",
        cta: "預約加盟諮詢",
      },
      {
        title: "活動合作",
        desc: "市集、快閃、企業活動、品牌合作與團體訂購。",
        icon: "ri-hand-heart-line",
        cta: "洽談合作",
      },
    ],
  },
  form: {
    sectionTitle: "留下你的需求",
    fields: {
      name: "姓名",
      phone: "電話",
      email: "Email",
      lineId: "LINE ID",
      type: "詢問類型",
      typeOptions: [
        "產品訂購",
        "冷凍宅配",
        "禮盒團購",
        "加盟諮詢",
        "活動合作",
        "其他",
      ],
      message: "需求說明",
      preferredTime: "希望聯絡時段",
      submit: "送出詢問",
    },
    note: "送出後，我們會依照你留下的需求與聯絡方式盡快回覆。若為急件或大量訂購，建議同步加入 LINE 官方帳號（@214epvsm）。",
  },
  brandInfo: {
    sectionTitle: "品牌資訊",
    items: [
      { label: "品牌名稱", value: "來加綉綉紅豆餅", icon: "ri-store-2-line" },
      { label: "LINE 官方帳號", value: "@214epvsm（https://lin.ee/xiNNjjf）", icon: "ri-chat-3-line" },
      { label: "電話", value: "請填入電話", icon: "ri-phone-line" },
      { label: "Email", value: "請填入 Email", icon: "ri-mail-line" },
      { label: "地址", value: "請填入門市或總部地址", icon: "ri-map-pin-line" },
      { label: "營業時間", value: "請填入營業時間", icon: "ri-time-line" },
    ],
    socials: [
      { label: "Instagram", icon: "ri-instagram-line", url: "#", placeholder: true },
      { label: "Facebook", icon: "ri-facebook-fill", url: "#", placeholder: true },
      { label: "Google 商家", icon: "ri-google-line", url: "#", placeholder: true },
    ],
  },
  map: {
    noAddress: "門市與服務據點資訊整理中，歡迎先加入 LINE 詢問",
  },
};